import { create } from "zustand";

export const useFakeMessageStore = create((set) => ({
  responseChunk: null,
  fakeConversationMessages: [],

  responseChunkTask: null,

  setFakeConversationMessages: (value) =>
    set(() => ({ fakeConversationMessages: value })),

  setResponseChunkTask: (value) => set(() => ({ responseChunkTask: value })),
}));
